import { DynamicFieldProperty_Enum } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { RelatedType } from '@weave/schema-gen-ts/dist/shared/sms/v1/enums.pb';
import { ReviewInvitationMutations } from '@frontend/api-reviews-invitation';
import { useTranslation } from '@frontend/i18n';
import {
  ReviewTemplateTypes,
  TemplateTypesWithProgressiveFlows,
  UseTemplateFlowResult,
} from '@frontend/integrated-messaging';
import { useAlert } from '@frontend/design-system';
import { useTemplateMessagingStore } from '../stores/template-selector-store';
import { UseTemplateFlowArgs } from '../types';

export const useAllTemplatesFlow = ({
  groupId,
  personId,
  renderTemplate,
  modalControl,
}: UseTemplateFlowArgs): UseTemplateFlowResult => {
  const { t } = useTranslation('inbox-templates');
  const { setSelectedMessageTemplateType, setSelectedMessageTemplate } = useTemplateMessagingStore(
    'setSelectedMessageTemplateType',
    'setSelectedMessageTemplate'
  );
  const reviewInvitationMutation = ReviewInvitationMutations.useReviewInvitationMutation();
  const alert = useAlert();

  return {
    popoverItem: {
      iconName: 'text-block',
      label: t('All Templates'),
      trackingId: `all-template-button`,
      onClick: modalControl.openModal,
    },
    tabItem: {
      tabLabel: t('All'),
      order: 1,
      templateSelectorProps: {
        groupIds: [groupId],
        onSelectTemplate: (template) => {
          if (TemplateTypesWithProgressiveFlows.includes(template.templateTypeSlug)) {
            setSelectedMessageTemplateType?.(template.templateTypeSlug);
            setSelectedMessageTemplate?.(template);
            return;
          } else if (ReviewTemplateTypes.includes(template.templateTypeSlug)) {
            reviewInvitationMutation.mutate(
              {
                locationId: groupId,
                personId,
                ...(!template.templateId.includes('static') && { templateId: template.templateId }),
              },
              {
                onSuccess: (data) => {
                  renderTemplate({
                    template,
                    linkData: [
                      {
                        link: data.invitation.invitationLink,
                        relatedId: data.invitation.invitationId,
                        relatedType: RelatedType.RELATED_TYPE_REVIEW,
                      },
                    ],
                    additionalBindings: {
                      [DynamicFieldProperty_Enum.REVIEW_REQUEST_LINK]: data.invitation.invitationLink,
                    },
                  });
                  modalControl.closeModal();
                },
                onError: () => {
                  alert.error(t('An error occurred generating the review invitation link. Please try again later.'));
                },
              }
            );
            return;
          }
          renderTemplate({ template });
          modalControl.closeModal();
        },
        templateTypes: [],
      },
    },
  };
};
